import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import en from 'src/constants/en'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisApiService } from 'src/services/contentAnalysisApi'
import {
  ContentAnalysisDeleteResponse,
  ContentAnalysisErrorResponse,
} from 'src/services/contentAnalysisApi/interfaces/contentAnalysis.interface'

interface UseDeleteContentAnalysisMutationParams {
  onError?: () => void
  onSuccess?: (data: ContentAnalysisDeleteResponse) => void
}

const deleteContentAnalysis = async (
  id: string
): Promise<ContentAnalysisDeleteResponse> => {
  return ContentAnalysisApiService.delete(id)
}

export const useDeleteContentAnalysisMutation = ({
  onError,
  onSuccess,
}: UseDeleteContentAnalysisMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteContentAnalysis,
    onError: (error: AxiosError<ContentAnalysisErrorResponse>) => {
      toast.error(
        error.response?.data?.error || en.CONTENT_ANALYSIS_DELETE_ERROR
      )
      onError?.()
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_CONTENT_ANALYSIS_LIST],
      })
      toast.success(en.CONTENT_ANALYSIS_DELETE_SUCCESS)
      onSuccess?.(data)
    },
  })
}
